import { Card, Typography } from "antd";
import { UserOutlined, TeamOutlined } from "@ant-design/icons";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CanSee } from "../../Shared/CanSee";
import React, { useState } from "react";
import { PersonaFinepModal } from "../PersonaFinepModal";
import ModalDelete from "../../Shared/ModalDelete";
import useModal from "../../../Hooks/useModal";
import { DeletePersonaFinep } from "../../../API/PersonaFinepAPI";
import Loader from "../../Shared/Loader";
import "./styles.css";
interface PersonaCompanyCardProps {
    type: 'Natural' | 'Legal';
    document: string;
    id: string;
    getPersons: () => Promise<void>;
}

export const PersonaCompanyCard = ({ type, document, id: entityId, getPersons }: PersonaCompanyCardProps) => {
    const { id, registerId } = useParams();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const { showModal, toggleShowModal } = useModal();
    const [loading, setLoading] = useState(false);

    const handleOpen = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpen(true);
    };

    const handleDelete = async () => {
        setLoading(true);

        await DeletePersonaFinep(entityId).catch(() => setLoading(false));
        await getPersons().catch(() => setLoading(false));

        setLoading(false);
    };

    const handleClick = (e: React.MouseEvent) => {
        type === 'Natural' ? handleOpen(e) : navigate(`/companyFinep/${entityId}/${registerId}/${id}`);
    }


    return (
        <>
            {loading && <Loader />}
                <Card className="physical-legal-card cursor-pointer" onClick={handleClick}>
                    <div className="content-card">
                        <div className="text-card">
                            <Typography className="physical-legal-card-title">
                                {type == 'Natural' ? 'Pessoa Física' : 'Pessoa Jurídica'}
                            </Typography>
                            <Typography className="physical-legal-card-subtitle"> {document} </Typography>
                        </div>
                        <div className="icons-container" >
                            {type == 'Natural' ? (
                                <UserOutlined className="icon-style" />
                            ) : (
                                <TeamOutlined className="icon-style" />
                            )}
                        </div>
                    </div>
                    {/* <div className="footer-card">
                        <CanSee rolesCan={['Manager', 'Consultant']} >
                            <FaPencilAlt className="cursor-pointer physical-legal-card-icon-button me-3" />
                            <FaTrash
                                className="cursor-pointer physical-legal-card-icon-button"
                                onClick={(e) => { e.stopPropagation(); toggleShowModal() }}
                            />
                        </CanSee>
                    </div> */}
                </Card>
            {/* </div> */}
            <PersonaFinepModal getPersons={getPersons} show={open} handleClose={handleClose} id={entityId} />
            <ModalDelete show={showModal} toggleShow={toggleShowModal} setResponse={handleDelete} />
        </>
    );
};